import { AnyAction } from 'redux';
import { REDIRECT_URL_UPDATE_SUCCESS, preventLogoutState } from '../types/preventLogout';

const initState: Partial<preventLogoutState> = {
  token: null,
  // arn_link: null,
};
function preventLogoutReducer(state = initState, action: AnyAction): Partial<preventLogoutState> {
  switch (action.type) {
    case REDIRECT_URL_UPDATE_SUCCESS: {
      const tokenObj = { token: action.tokenObj.token };
      return {
        ...state,
        ...tokenObj,
      };
    }
    default:
      return state;
  }
}

export default preventLogoutReducer;
